var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox"},[(_vm.upURL)?_c('input',{attrs:{"type":"file","accept":"image/*","multiple":_vm.multiple,"capture":"user"},on:{"change":_vm.change}}):_c('input',{attrs:{"type":"file","accept":"image/*","multiple":_vm.multiple},on:{"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }